<template>
	<div>
		<NavHeader/>
		<div class="divider"></div>
		<div class="container">
			<div class="process">
				<h3>Business Payments
					<br/> made easy!</h3>

				<div class="process-timeline">
					<div class="process-list">
						<img src="/static/commercial/img/icons/recipient.png" alt=""/>
						<p>Enter recipient details & amount</p>
					</div>

					<img src="/static/commercial/img/icons/line.png" alt="" class="line">

					<div class="process-list">
						<img src="/static/commercial/img/icons/payment.png" alt="">
						<p>Make payment</p>
					</div>

					<img src="/static/commercial/img/icons/line.png" alt="" class="line">

					<div class="process-list">
						<img src="/static/commercial/img/icons/money.png" alt="">
						<p>Money transferred</p>
					</div>

				</div>
			</div>
			<!-- eo process -->
		</div>

		<div class="divider"></div>

		<div class="mode">
			<div class="container">
				<h3>Mode of payments</h3>
				<div class="row">
					<div class="col-lg-3 text-center">
						<div class="modes">
							<div class="mode-list">
								<img src="/static/commercial/img/icons/accountcredit.png" alt="">
								<p>Account Credit / Bank Transfer</p>
							</div>
						</div>
					</div>
					<div class="col-lg-9">
						<p class="normal">Payments can be deposited directly into the Beneficiary's bank account</p>
					</div>
				</div>
				<div class="divider"></div>
				<div class="row">
					<div class="col-lg-3 text-center">
						<div class="modes">
							<div class="mode-list">
								<img src="/static/commercial/img/icons/cashpickup.png" alt="">
								<p>Swift</p>
							</div>
						</div>
					</div>
					<div class="col-lg-9">
						<p class="normal">SWIFT Code or BIC (Bank Identifier Code) is a unique code to identify financial and non-financial institutions.SWIFT
							payments are a type of international transfer sent via the SWIFT international payment network.The SWIFT international
							payment network is one of the largest financial messaging systems in the world.</p>
					</div>
				</div>
				<div class="divider"></div>
				<h3>FPX Banks <br/> (Corporate Internet Banking)</h3>
				<div class="row">
						<div class="col-lg-12">
								<div class="main-table wb-main-table">
									<div class="table-responsive-md c-table-border">
										<table class="table table-striped table-bordered">
											<tbody>
												<tr v-for="(item,index) in FPXBanks" :key="{index}">
													<td style="width:33%;" v-for="subItem in item" :key="subItem.Id">{{subItem.BankDesc}}</td>
													<td v-if="item.length<3" :colspan="3-item.length"></td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
						</div>
					</div>
			</div>
		</div>
		<!-- eo mode -->


		<div class="divider"></div>


		<div class="container mgb30">

			<div class="second-header">
				<h3>Delivery Time & Service Charges</h3>
			</div>

			<div class="main-table wb-main-table">
				<h3 class="table-header">
					<img src="/static/commercial/img/icons/bank.png" alt="">Bank Transfer</h3>

				<div class="table-responsive-md c-table-border">
					<table class="table table-striped table-bordered">
						<thead>
							<tr>
								<th scope="col">Destination Country</th>
								<th scope="col">Service Charge</th>
								<th scope="col">Delivery Time
									<br>(before 5pm)</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="item in vModel.bankTransferList" :key="item.FlagCode">
								<th class="country-list">
									<img :src="'/static/flags/'+ item.FlagCode + '.png'" alt="">{{item.Country}}</th>
								<td>{{item.ServiceCharge}}</td>
								<td>{{item.DeliveryTime}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<!-- eo main table -->
		</div>

		<div class="container">
			<div class="main-table wb-main-table">
				<h3 class="table-header">
					<img src="/static/commercial/img/icons/swift.png" alt="">Swift</h3>

				<div class="table-responsive-md c-table-border">
					<table class="table table-striped table-bordered">
						<thead>
							<tr>
								<th scope="col">Destination Country</th>
								<th scope="col">Service Charge</th>
								<th scope="col">Delivery Time
									<br>(before 5pm)</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="item in vModel.swiftList" :key="item.FlagCode">
								<th class="country-list">
									<img :src="'/static/flags/'+ item.FlagCode + '.png'" alt="">{{item.Country}}</th>
								<td>{{item.ServiceCharge}}</td>
								<td>{{item.DeliveryTime}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<!-- eo main table -->
			<p class="note">*We can process USD payments to all destination countries via SWIFT.</p>
		</div>

		<div class="divider"></div>

		<div class="container">
			<div class="faqs-link">
				<h4>All your questions answered.</h4>

				<p>If you have a question, you'll probably find the answer on our
					<router-link :to="'/faq/business'">FAQ Page</router-link>
					<!-- <a href="faq.html">FAQ Page</a> -->
					.</p>
			</div>
		</div>
		<div class="divider hidden"></div>
		<BusinessHorizon/>

	</div>
</template>
<script>
	import NavHeader from "../../shared/commercial/NavHeader.vue";
	import BusinessHorizon from "../../shared/commercial/BusinessHorizon.vue";
	import ListService from "../../services/list";

	export default {
		name: "WorksBiz",

		components: { BusinessHorizon, NavHeader },

		created() { }
		,
  beforeRouteEnter(to, from, next) {
  
    var promises = [];
    promises.push(
      ListService.get("payment/providers"),
	  ListService.get('/static/data/banktransfer.json'),
	  ListService.get('/static/data/swift.json')
    );

    Promise.all(promises).then(response => {

		next(p=>{
			var activeBanks = response[0].body.Individual;
				p.FPXBanks = activeBanks.map((e,i)=>{
					return i%3===0? activeBanks.slice(i,i+3) : null;
				}).filter(i=>{
					return i;
				});
				p.vModel.bankTransferList = response[1].body;
				p.vModel.swiftList = response[2].body;
			});
		})},
		data() {
			return {
				FPXBanks: [],
				ExchangeRateCollection: [],
				RecentTransactionCollection: [],
				NotificationCollection: [],

				RecipientCollection: null,
				ClassBadge: { "badge-yellow": true },
				itemTemplate:
					'<div class="m-b-sm m-t-sm">#:data.Fullname# <br/><img style="width:24px;" src="static/img/flags/#:data.FlagCode#.png" />#:data.CountyName#<br/> #:data.PayoutMode#</div>',
				vModel: {
					RecipientId: null,
					bankTransferList: [],
				swiftList: []
				}
			};
		},
		methods: {
			badgeColor: function (statusid) {
				var color = { "badge-yellow": true };

				switch (statusid) {
					case 1:
					case 2:
					case 3:
					case 4:
					case 6:
					case 7:
					case 8:
					case 14:
					case 15:
						color = { "badge-yellow": true };
						break;
					case 5:
						color = { "badge-green": true };
						break;
					case 9:
					case 11:
					case 12:
					case 19:
					case 20:
					case 21:
						color = { "badge-red": true };
						break;

					case 10:
					case 13:
						color = { "badge-grey": true };
						break;
				}

				return color;
			},
			sendMoney: function (e) {
				window.Vue.$router.push(e.sender._old);
			},
			pullpromotion: function () { }
		}
	};
</script>
